export const getDropdownDirections = (
    elementRect: {left: number; right: number},
    isRTLDir: boolean,
    dropdownWidth: number
) => {
    if (isRTLDir) {
        return elementRect.right > dropdownWidth ? 'rightSide' : 'leftSide';
    }
    return elementRect.left + dropdownWidth < window.innerWidth ? 'rightSide' : 'leftSide';
};
